export default __webpack_public_path__ + "static/media/TV_Mundo_Maior.122b88ed.png";